import type {Row} from './api';
const positive=(value:unknown)=>Number.isInteger(Number(value))&&Number(value)>0?String(Number(value)):null;
/** Accept only known same-origin application routes, never an arbitrary API/search URL. */
export function safeApplicationUrl(value:unknown):string|null{
 if(typeof value!=='string'||!value.startsWith('/')||value.startsWith('//')||value.includes('\\')||value.length>2048)return null;
 let url:URL;try{url=new URL(value,'https://crm.invalid')}catch{return null}
 if(url.origin!=='https://crm.invalid')return null;
 const detail=url.pathname.match(/^\/(deals|tasks|calendar|meetings|control|organizations|contacts|interactions|projects)\/(\d+)\/?$/);
 if(detail){const route=detail[1]==='meetings'?'calendar':detail[1]==='projects'?'finance':detail[1];url.pathname='/'+route;url.searchParams.set(detail[1]==='projects'?'project':'item',detail[2])}
 if(!/^\/(?:clients(?:\/\d+)?|deals|tasks|calendar|control|organizations|contacts|interactions|finance|products|workspace|procurements)\/?$/.test(url.pathname))return null;
 return url.pathname.replace(/\/$/,'')+url.search+url.hash;
}
export function searchResultUrl(result:Row):string|null{
 const provided=safeApplicationUrl(result.url);if(provided)return provided;
 const type=String(result.type||'').split('.').at(-1);const id=positive(result.id),region=positive(result.region||result.region_id);if(!id)return null;
 if(type==='deal')return `/deals?item=${id}`;
 if(type==='contract'){const deal=positive(result.deal||result.deal_id);return deal?`/deals?item=${deal}&tab=contracts&contract=${id}`:null}
 if(type==='task')return `/tasks?item=${id}`;
 if(type==='meeting')return `/calendar?item=${id}`;
 if(type==='project')return `/finance?project=${id}`;
 if(type==='controlitem'||type==='control_item'||type==='control')return `/control?item=${id}`;
 if(type==='region')return `/clients/${id}`;
 if(type==='organization')return region?`/clients/${region}?tab=organizations&record=${id}`:`/organizations?item=${id}`;
 if(type==='contact')return region?`/clients/${region}?tab=contacts&record=${id}`:`/contacts?item=${id}`;
 if(type==='interaction')return `/interactions?item=${id}`;
 return null;
}

/** Notification IDs identify their typed target, not the notification row itself. */
export function notificationObjectUrl(notification:Row):string|null{
 const id=positive(notification.object_id);if(!id)return null;
 const type=String(notification.object_type||'');
 if(type==='procurement'||type==='crm.procurement')return `/procurements?item=${id}`;
 // Legacy region_transfer identifies the transfer, not its region: no invented route.
 return searchResultUrl({id:Number(id),type});
}
